import type { ReactNode } from 'react';

export interface CardProps {
  title?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Card({ title, actions, children, className }: CardProps) {
  return (
    <section className={['au-card', className ?? ''].filter(Boolean).join(' ')}>
      {title !== undefined || actions !== undefined ? (
        <header className="au-card__header">
          {title !== undefined ? <h2 className="au-card__title">{title}</h2> : <span />}
          {actions}
        </header>
      ) : null}
      <div className="au-card__body">{children}</div>
    </section>
  );
}
